import { JSX } from "react";

function PageHeader(): JSX.Element {
  return (
    <div className="container">
      <div className="row">
        <div className="main col-md-12">
          <h1 className="page-title mt-4">
            <span className="bone">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </span>
          </h1>
        </div>
      </div>
    </div>
  );
}

export { PageHeader };
